// extracted by extract-css-chunks-webpack-plugin
module.exports = {"left_box":"left_box-25_sw-Bd"};